// Configuración de la base de datos
const DB_NAME = 'WemaxImageDB';
const DB_VERSION = 1;
const STORE_NAME = 'profileImages';

// Clase para manejar el almacenamiento de imágenes
class ImageStorage {
  constructor() {
    this.db = null;
    this.initDB();
  }

  // Inicializar la base de datos
  async initDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = () => {
        console.error("Error al abrir la base de datos");
        reject(request.error);
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;
        resolve(this.db);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        // Crear el almacén de objetos si no existe
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'id' });
        }
      };
    });
  }

  // Guardar una imagen
  async saveImage(userId, imageBlob) {
    try {
      // Asegurarse de que la base de datos está inicializada
      if (!this.db) {
        await this.initDB();
      }

      return new Promise((resolve, reject) => {
        // Convertir el Blob a Base64
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result;
          
          const transaction = this.db.transaction([STORE_NAME], 'readwrite');
          const store = transaction.objectStore(STORE_NAME);

          // Guardar la imagen con el ID del usuario
          const request = store.put({
            id: userId,
            image: base64data,
            timestamp: new Date().getTime()
          });

          request.onsuccess = () => resolve(base64data);
          request.onerror = () => reject(request.error);
        };

        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(imageBlob);
      });
    } catch (error) {
      console.error('Error al guardar la imagen:', error);
      throw error;
    }
  }

  // Obtener una imagen
  async getImage(userId) {
    try {
      if (!this.db) {
        await this.initDB();
      }

      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([STORE_NAME], 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.get(userId);

        request.onsuccess = () => {
          const data = request.result;
          resolve(data ? data.image : null);
        };

        request.onerror = () => reject(request.error);
      });
    } catch (error) {
      console.error('Error al obtener la imagen:', error);
      throw error;
    }
  }

  // Eliminar una imagen
  async deleteImage(userId) {
    try {
      if (!this.db) {
        await this.initDB();
      }

      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([STORE_NAME], 'readwrite');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.delete(userId);

        request.onsuccess = () => resolve(true);
        request.onerror = () => reject(request.error);
      });
    } catch (error) {
      console.error('Error al eliminar la imagen:', error);
      throw error;
    }
  }
}

// Exportar una única instancia del servicio
const imageStorage = new ImageStorage();
export default imageStorage;
